import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusPage } from '../../Components/StatusPage/StatusPage';

export const ServerError = ({ onRetry = () => window.location.reload() }) => {
  const navigate = useNavigate();

  return (
    <StatusPage
      code="500"
      heading="Something went wrong."
      description="We hit a technical snag while loading this page. Please try again in a moment."
      secondaryLabel="Try Again"
      onSecondaryClick={onRetry}
      footer={<>Still having trouble? <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Go back home</a> or <a href="https://www.natureland.com.sg/locations/" target="_blank" rel="noopener noreferrer">contact our support team</a>.</>}
    />
  );
};

export default ServerError;
